import React from 'react';
import ConfiguratorOptionsList from './ConfiguratorOptionsList.js';
import './Configurator.css';

export default class Configurator extends React.Component {
	
	setStateP(opt) { return new Promise(resolve => this.setState(opt, resolve)) }
	
	constructor(props) {
		super(props);
		this.state = {
			selected_items: {},
			filterErrors: {},
			displayMessages: !!props.displayMessages,
			scrollToGroup: null,
		}
		this.currencyDisplay = this.currencyDisplay.bind(this);
		this.updateUrlHash = this.updateUrlHash.bind(this);
		this.updateTotals = this.updateTotals.bind(this);
		this.selectedItemsChangeAfter = this.selectedItemsChangeAfter.bind(this);
		this.submitCallback = this.submitCallback.bind(this);
	}
	
	componentDidMount() {
		
		if(this.props.setSubmits)
			this.props.setSubmits(this.submitCallback);
		
		// connect with potential outside selector setters aka .product-options-link
		if(this.props.setHashChangers)
			this.props.setHashChangers(hash => this.setSelectedItemsByHash(hash, true));
		
		if(this.props.updateUrlHash && window.location.hash)
			this.setSelectedItemsByHash(window.location.hash, false)
		else if(this.props.initialSelection)
			this.setSelectedItems(this.props.initialSelection)
		else
			this.setDefaultItems()
	}
	
	componentDidUpdate(prevProps) {
		if(!!this.props.pricesOverride !== !!prevProps.pricesOverride) {
			this.updateTotals();
		}
	}
	
	options() {
		// @todo
		return this.props.options;
	}
	
	async selectedItemsChangeAfter(recursionIndex = 0) {
		
		// готовим данные
		
		let selectedLinkIds = [];
		let linkGroupIdMap = {};
		let groupsMap = {};
		let groupsSelected = {};
		let rowsMap = {};
		for(let group of this.props.options)
		{
			groupsMap[group.id] = group;
			groupsSelected[group.id] = [];
			for(let row of this.getLinksDataWithQty(group))
			{
				if(!row.link.id) continue; // hidden option
				linkGroupIdMap[row.link.id] = group.id;
				rowsMap[row.link.id] = row;
				if(row.qty > 0)
				{
					selectedLinkIds.push(row.link.id);
					groupsSelected[group.id].push(row.link.id);
				}
			}
		}
		
		
		// выполняем проверки
		
		let filterErrors = {};
		for(let selectedLinkId of selectedLinkIds)
		{
			const selectedRow = rowsMap[selectedLinkId];
			
			// если фильтров нет - не надо ничего делать
			if(!selectedRow.link.filter) continue;
			
			// если фильтр удовлетворен - не надо ничего делать
			let fulfilled = false;
			for(let id of selectedLinkIds)
				if(selectedRow.link.filter.includes(id))
				{
					fulfilled = true;
					break;
				}
			if(fulfilled) continue;
			
			// если фильтр не удовлетворен, то нужно найти конфликтующую опцию
			// (выбранная опция из той же секции, что и dependent опции)
			
			// найдем все группы
			let dependantGroupIds = {};
			for(let dependantId of selectedRow.link.filter)
			{
				const groupId = linkGroupIdMap[dependantId];
				if(!dependantGroupIds[groupId])
					dependantGroupIds[groupId] = {
						selected: groupsSelected[groupId] || [],
						expected: []
					};
				dependantGroupIds[groupId].expected.push(dependantId);
			}
			
			// найдем конфликты
			let conflictingGroupId = null;
			let conflictingLinkId = null;
			for(let groupId in dependantGroupIds)
			{
				const g = dependantGroupIds[groupId];
				
				// нас не интересуют группы, в которых еще ничего не выбрано
				if(g.selected.length === 0) continue;
				
				// проверяем может в этой группе уже и так выбрано то, что нам нужно
				if(g.expected.filter(id => g.selected.includes(id)).length > 0) continue;
				
				conflictingGroupId = groupId;
				conflictingLinkId = g.selected[0];
				break;
			}
			
			// если конфликтующая опция еще не выбрана - не надо ничего делать
			if(!conflictingGroupId || !conflictingLinkId) continue;
			
			
			// составляем сообщение
			const selectedOptionGroup = groupsMap[linkGroupIdMap[selectedRow.link.id]];
			const message = selectedRow.link.filterMessage || `Invalid option selected. Select another option in "%dependentSection%" section`;
			const replacements = {
				"%filterSection%": selectedOptionGroup.title,
				"%filterOption%": selectedRow.link.title,
				"%dependentSection%": groupsMap[conflictingGroupId].title,
				"%dependentOption%": rowsMap[conflictingLinkId].link.title,
			};
			if(!filterErrors[selectedOptionGroup.id])
				filterErrors[selectedOptionGroup.id] = [];
			filterErrors[selectedOptionGroup.id].push(
				Object.keys(replacements).reduce(
					(s, k) => s.replaceAll(k, replacements[k]),
					message
				)
			);
		}
		
		return this.setStateP({
			filterErrors: filterErrors,
		});
	}
	
	// получить список всех выбранных линков группы
	getLinksDataWithQty(group, selectedItems = null) {
		
		if(!selectedItems) selectedItems = this.state.selected_items;
		
		const keyId = group.catalog_product_option_id;
		const selectedValues = selectedItems[keyId] || [];
		let ret = [];
		
		for(let link of group.items)
		{
			// totalCount
			let qty = 0;
			if(group.type === 'hidden')
				// скрытые всегда добавляются и всегда с первым количеством
				// у них его вообще не должно быть больше одного
				qty = parseInt(Object.keys(link.counts)[0]);
			else
				// для обычных находим выбранное количество
				qty = parseInt(Object.keys(link.counts)
					.find(c => selectedValues.includes(link.counts[c])));
					
			// если нет количества, то не выбрано
			// if(!qty) continue;
			
			ret.push({
				link: link,
				qty: qty || 0,
				type_id: qty ? link.counts[qty] : null,
			});
		}
		
		return ret;
	}
	
	validateGroup(group) {
		
		if(group.type === 'hidden') return null;
		
		let errors = [];
		
		if(this.state.filterErrors[group.id])
			errors = [...this.state.filterErrors[group.id]];
		
		const keyId = group.catalog_product_option_id;
		const selectedValues = this.state.selected_items[keyId] || [];
		
		// check max_qty
		if(group.max_qty)
		{
			let totalCount = 0;
			for(let v of this.getLinksDataWithQty(group))
				totalCount += v.qty;
			if(totalCount > group.max_qty)
				errors.push("max_qty_exceeded");
		}
		
		// check required
		if(group.is_required)
		{
			if(selectedValues.length === 0)
				errors.push("required_empty");
		}
		
		if(errors.length === 0) return null;
		
		return errors.filter((value, index, array) => array.indexOf(value) === index);
	}
	
	validationErrors() {
		let messages = [];
		let firstValidationErrorGroup = null;
		for(let group of this.props.options)
		{
			let groupErrors = this.validateGroup(group);
			if(!groupErrors) continue;
			
			messages.push(groupErrors);
			
			if(firstValidationErrorGroup === null)
				firstValidationErrorGroup = group;
		}
			
		if(messages.length === 0)
			return null;
			
		return {
			list: messages,
			firstGroup: firstValidationErrorGroup,
		}
	}
	
	getDescription() {
		let description = [];
		for(let group of this.props.options)
		{	
			let desc = [];
			let ids = [];
			for(let v of this.getLinksDataWithQty(group))
			{
				if(!v.qty) continue;
				const title = v.link.option ? v.link.option.name : v.link.title;
				if(v.qty === 1)
					desc.push(title);
				else
					desc.push(`${v.qty} x ${title}`);
				ids.push(v.type_id);
			}
			if(group.type !== 'hidden' && desc.length > 0)
				description.push({
					label: group.title,
					option_id: group.catalog_product_option_id,
					value: desc.join(", "),
					option_value: ids.join(','),
				});
		}
		return description;
	}
	
	submitCallback() {
		const validationErrors = this.validationErrors();
		if(validationErrors)
		{
			this.setState({
				displayMessages: true,
				scrollToGroup: validationErrors.firstGroup.id,
			});
		}
		return {
			validationErrors: validationErrors ? validationErrors.list : null,
			totals: this.calculateTotals(true),
		}
	}
	
	setDefaultItems() {
		let selected_items = {};
		for(let group of this.props.options)
		{
			if(group.archived) continue;
			if(group.type === 'hidden') continue;
			const multiple = group.type !== 'radio';
			let list = [];
			for(let link of group.items)
			{
				if(link.archived) continue;
				if(link.admin && !this.props.adminMode) continue;
				if(link.default)
				{
					list.push(Object.values(link.counts)[0]);
					if(!multiple) break;
				}
			}
			if(list.length > 0)
				selected_items[group.catalog_product_option_id] = list;
		}
		
		return this.setStateP({
				selected_items: selected_items
			})
			.then(this.selectedItemsChangeAfter)
			.then(this.updateTotals)
	}
	
	async setSelectedItemsByHash(hash, updateUrl) {
		const items = hash.split('#').join('') // избавляемся от потенциального диеза
			.split(';') // делим на опции
			.map(v => v.split(':')) // делим на ключ и значения
			.filter(v => !isNaN(v[0])) // выкидываем пустые или бракованные ключи
			.filter(v => v[1]) // выкидываем пустые значения
			.map(v => ({
				k: parseInt(v[0]),
				v: String(v[1]).split(',')
					.filter(v => !isNaN(v))
					.map(v => parseInt(v))
					.filter(v => v)
			}))
			.filter(r => r.v) // выкидываем пустые значения
			.reduce((o, r) => Object.assign(o, { // превращаем список в хеш
				[r.k]: r.v
			}), {});
			
		await this.setSelectedItems(items);
		
		if(updateUrl)
			this.updateUrlHash();
	}
	
	setSelectedItems(items) {
		let optionIds = [];
		let valueIds = [];
		for(let group of this.props.options)
		{
			optionIds.push(group.catalog_product_option_id)
			for(let link of group.items)
				for(let id of Object.values(link.counts))
					valueIds.push(id);
		}
		
		let clearedItems = {};
		for(let option_id in items)
		{
			if(!optionIds.includes(parseInt(option_id))) continue;
			let values = items[option_id];
			if(!values.map)
				values = [values];
			values = values
				.map(v => parseInt(v))
				.filter(v => v)
				.filter(v => valueIds.includes(v))
			if(values.length < 1) continue;
			clearedItems[option_id] = values;
		}
		
		return this.setStateP({
			selected_items: clearedItems
		})
		.then(this.selectedItemsChangeAfter)
		.then(this.updateTotals)
	}
	
	linkPrice(link, qty) {
		if(!this.props.pricesOverride)
			return link.actual_price;
		const type_id = link.counts[qty];
		if(type_id && this.props.pricesOverride[type_id])
			return this.props.pricesOverride[type_id];
		return link.actual_price;
	}
	
	// минимальная цена группы 
	// включена в стартовую и отнимается от отображаемых цен)
	// влияет на формирование тотала и индивидуальные цены линков
	getGroupIncludedPrice(group) {
		
		if(!group.is_required) return 0;
		
		let included_price = null;
		for(let link of group.items)
		{
			const min_qty = Math.min(...Object.keys(link.counts).map(v => parseInt(v)));
			const linkPrice = this.linkPrice(link, min_qty);
			if(linkPrice === null) continue;
			const price = (linkPrice || 0) * min_qty;
			if(included_price === null || included_price > price)
				included_price = price
		}
		return included_price || 0;
	}
	
	updateTotals() {
		if(!this.props.onUpdate) return;
		let totals = this.calculateTotals(true);
		const validationErrors = this.validationErrors();
		let upd = {
			validationErrors: validationErrors ? validationErrors.list : null,
			values: this.state.selected_items,
		};
		for(let k in totals)
			upd[`${k}Price`] = totals[k];
		this.props.onUpdate(upd);
	}
	
	calculateTotals(count_percent_price, selectedItems = null) {
		let hidden_groups_price = 0;
		let included_price = 0;
		let normal_price = 0;
		let custom_total = 0;
		let ramTotal = 0;
		let wattsTotal = 0;
		let percent_whole_links = [];
		
		if(this.props.pricesOverride && this.props.pricesOverride.hidden)
			hidden_groups_price += this.props.pricesOverride.hidden;
		
		for(let group of this.props.options)
		{
			if(group.type === 'hidden')
			{
				for(let v of this.getLinksDataWithQty(group, selectedItems))
				{
					if(!this.props.pricesOverride || !this.props.pricesOverride.hidden)
						hidden_groups_price += this.linkPrice(v.link, v.qty) * v.qty;
					wattsTotal += (v.link.watts || 0) * v.qty;
					if(this.props.customTotalCalculator)
						custom_total += this.props.customTotalCalculator(v, group);
				}
				continue;
			}
			
			const customData = this.customData(group);
			if(customData.ram)
				ramTotal += customData.ram;
			
			const multiple = group.type !== 'radio';
			let groupHasSelected = false;
			for(let v of this.getLinksDataWithQty(group, selectedItems))
			{
				if(this.props.customTotalCalculator)
					custom_total += this.props.customTotalCalculator(v, group);
				
				if(!v.qty) continue;
				
				groupHasSelected = true;
				
				if(v.link.price_type === 'percent_whole')
				{
					percent_whole_links.push(v.link);
					continue; // эти рассмотрим потом
				}
					
				// складываем обычную цену
				// (если передать пустой массив, то это будет стартовая цена)
				normal_price += (this.linkPrice(v.link, v.qty) || 0) * v.qty;
				
				wattsTotal += (v.link.watts || 0) * v.qty;
				
				// если это одиночный элемент, то больше ничего не добавляется
				if(!multiple) break;
			}
			
			if(!groupHasSelected)
				included_price += this.getGroupIncludedPrice(group);
		}
			
		let base_price = hidden_groups_price + included_price + normal_price;
		if(!count_percent_price) return { base: base_price };
		
		let percent_price = percent_whole_links.reduce((sum, link) => sum + 0.01 * base_price * link.price, 0)
		return {
			base: base_price,
			total: base_price + percent_price,
			custom: custom_total,
			ram: ramTotal,
			watts: wattsTotal,
		};
	}
	
	updateUrlHash() {
		if(!this.props.updateUrlHash) return;
		const hash = this.getUrlHash();
		if(hash === window.location.hash)
			return;
		if(hash === '')
			window.history.pushState("", document.title, window.location.pathname + window.location.search);
		else
			window.location.hash = hash;
	}
	getUrlHash() {
		return Object.keys(this.state.selected_items)
			.sort((a, b) => a - b)
			.filter(k => this.state.selected_items[k].length > 0)
			.map(k => String(k) + ':' + this.state.selected_items[k].sort((a, b) => a - b).join(','))
			.join(';');
	}
	
	onGroupSelectionChanged(catalog_product_option_id, selection) {
		return this.setStateP(state => {
			state.selected_items[catalog_product_option_id] = selection;
			return {
				selected_items: state.selected_items,
				scrollToGroup: null,
			}
		})
		.then(this.selectedItemsChangeAfter)
		.then(this.updateUrlHash)
		.then(this.updateTotals)
	}
	
	currencyDisplay(value, comma = false) {
		if(this.props.formatCurrency)
			return this.props.formatCurrency(value, comma);
		return `$${Math.round(value)}`
	}
	
	renderProfiles() {
		if(!this.props.profiles) return null;
		
		const baseUrl = document.location.href.split('#').shift();
		
		const profiles = [];
		for(let cfg of this.props.profiles)
		{
			const hash = cfg.link.split('#').pop();
			
			const parsedHash = {};
			for(let v of hash.split(';'))
			{
				let [g,ls] = v.split(':');
				parsedHash[parseInt(g)] = ls.split(',').map(v => parseInt(v));
			}
			
			const totals = this.calculateTotals(true, parsedHash);
			
			profiles.push({
				link: `${baseUrl}#${hash}`,
				title: cfg.title,
				hash,
				price: totals.total || 0,
			});
		}
		
		const currentHash = this.getUrlHash();
		return <div className="preconfigs">
			<h2>{this.props.profilesTitle || 'Recommended Configurations'}</h2>
			<div>
				{profiles.map(cfg => <a
					key={cfg.hash}
					href={cfg.link}
					className={currentHash === cfg.hash ? "selected" : null}
					onClick={e => {
						e.preventDefault();
						this.setSelectedItemsByHash(cfg.hash, true);
						return false;
					}}
				>
					<b dangerouslySetInnerHTML={{__html:cfg.title}}/>
					<i>{this.currencyDisplay(cfg.price, true)}</i>
				</a>)}
			</div>
		</div>
	}
		
	// отдельно генерируем поля HTML формы
	renderFormHiddenInputs() {
		
		if(!this.props.renderHiddenInputs) return null;
		
		let inputs = [];
		
		const hash = this.getUrlHash();
		
		inputs.push(<input
			key="product_link"
			type="hidden"
			name="product_link"
			value={`${window.location.href}${hash?'#':''}${hash}`}
		/>);
		inputs.push(<input
			key="product_description"
			type="hidden"
			name="product_description"
			value={JSON.stringify(this.getDescription())}
		/>);
		inputs.push(<input
			key="product_price"
			type="hidden"
			name="product_price"
			value={this.calculateTotals(true).total}
		/>);
		
		for(let group of this.props.options)
		{
			// скрытые группы уже учтены в базовой цене товара,
			// добавлять ее не надо
			if(group.type === 'hidden') continue;
			
			const keyId = group.catalog_product_option_id;
			
			let selectedValues = this.state.selected_items[keyId] || [];
			
			const multiple = group.type !== 'radio';
			
			groupLinks:
			for(let link of group.items)
				for(let value of Object.values(link.counts))
					if(selectedValues.includes(value))
					{
						inputs.push(<input
							key={`${keyId}-${value}`}
							type="hidden"
							name={`options[${keyId}]${multiple ? '[]' : ''}`}
							value={value}
						/>)
						if(!multiple) break groupLinks;
					}
		}
		return inputs;
	}

	customData(group) {
		let ret = {};
		if(group.html_class && String(group.html_class).includes('count-ram-total'))
		{
			const selected = this.state.selected_items[group.catalog_product_option_id] || null;
			if(!selected) return '';
			
			let sum = 0;
			for(let link of group.items)
			{
				const selected_id = selected.find(v => Object.values(link.counts).includes(v));
				if(!selected_id) continue;
				const count = Object.keys(link.counts).find(c => link.counts[c] === selected_id) || 1;
				let text = link.option ? link.option.name : link.title;
				let value = parseInt(text.replace(/^[^0-9]+/g, ''));
				sum += count * value;
			}
			if(sum > 0)
			{
				ret.subtitle = ` (${sum}GB Total)`;
				ret.ram = sum;
			}
		}
		return ret;
	}
	
	submitBtnClick(type) {
		const status = this.submitCallback();
		if(status.validationErrors) return;
		if(this.props.onSubmit)
			this.props.onSubmit(type);
	}
	
	render() {
		
		const totals = this.calculateTotals(true);
		
		let groupedGroups = {};
		for(let group of this.props.options)
		{
			if(group.type === 'hidden') continue;
			let group_title = group.grouptitle || "default";
			if(group.archived)
				group_title = "Archived";
			if(!groupedGroups[group_title])
				groupedGroups[group_title] = [];
			groupedGroups[group_title].push(group);
		}
		
		const groupTitles = Object.keys(groupedGroups)
			.sort((a, b) => Number(a === "Archived") - Number(b === "Archived"));
		
		return <div className="configurator">
		
		{this.renderFormHiddenInputs()}
		
		{this.renderProfiles()}
		
		{groupTitles.map(group_title => <div key={group_title} className="group">
			{group_title !== 'default' ? <div className="group-head">{group_title}</div> : null}
			
			{groupedGroups[group_title]
				.map(group => <ConfiguratorOptionsList
					key={group.id}
					adminMode={this.props.adminMode}
					currencyDisplay={this.currencyDisplay}
					className={group.className}
					
					title={group.title}
					html_class={group.html_class}
					customSubtitle={this.customData(group).subtitle || ''}
					short_descr={this.props.displayDescriptions ? group.short_descr : null}
					long_descr={this.props.displayDescriptions ? group.long_descr : null}
					image={group.image}
					image_crop={group.image_crop}
					image_crop2x={group.image_crop2x}
					max_qty={group.max_qty}
				
					multiple={group.type !== 'radio'}
					is_required={group.is_required}
					
					items={group.items}
					selected={this.state.selected_items[group.catalog_product_option_id] || []}
					onChange={new_selection => this.onGroupSelectionChanged(group.catalog_product_option_id, new_selection)}
					
					displayMessages={this.state.displayMessages || this.state.filterErrors[group.id]}
					messages={this.validateGroup(group)}
					
					base_price={totals.base}
					included_price={this.getGroupIncludedPrice(group)}
					pricesOverride={this.props.pricesOverride}
					
					scrollTo={this.state.scrollToGroup === group.id}
				/>)
			}
			
		</div>)}
		
			{this.props.diplayTotals ? <div className="configurator-totals">
				<div className="tw-flex tw-items-center">
					<div className="tw-flex-auto tw-w-[120px] tw-text-[32px] tw-text-center">
						{this.currencyDisplay(totals.total, true)}
						{totals.watts ? <div className="tw-text-center tw-text-[10px]">
							<i className="fa fa-bolt tw-mr-2"></i>
							{totals.watts} Watts
						</div> : null}
					</div>
					<div className="tw-flex-auto tw-w-[300px] tw-text-center tw-whitespace-nowrap">
						<button
							type="button"
							className="btn btn-success tw-inline-block tw-mb-1 tw-px-2 tw-ml-2"
							onClick={() => this.submitBtnClick('cart')}
						>
							<span className="fa fa-shopping-cart tw-mr-2"></span>
							Add to Cart
						</button>
						<button
							type="button"
							className="btn btn-primary tw-inline-block tw-mb-1 tw-px-2 tw-ml-2"
							onClick={() => this.submitBtnClick('quote')}
						>
							<span className="fa fa-print tw-mr-2"></span>
							Download Quote
						</button>
					</div>
				</div>
				<div className="tw-text-center tw-whitespace-nowrap">
					<button
						className="btn btn-link tw-normal-case tw-px-2"
						onClick={() => this.submitBtnClick('quote')}
					>
						<i className="fa fa-graduation-cap"></i>
						{' '}
						<span>EDU, GOV discounts</span>
					</button>
					<button
						className="btn btn-link tw-normal-case tw-px-2"
						onClick={() => this.submitBtnClick('quote')}
					>
						<i className="fa fa-briefcase"></i>
						{' '}
						<span>B2B/reseller discounts</span>
					</button>
					<a
						className="btn btn-link tw-normal-case tw-px-2" 
						href="/financing"
					>
						<i className="fa fa-percent"></i>
						{' '}
						<span>Financing</span>
					</a>
				</div>
			</div> : null}
		</div>
	}
}
